document.addEventListener("DOMContentLoaded", function() {

    let swiperSelector = document.querySelector('[data-detail-project-gallery]');
    if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
        return;

    // swiper detail - foto projektu (detail-2)
    //============================================
    (function () {
        let swiperDetail = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },

            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 2,
                },
                2050: {
                    slidesPerView: 3,
                },
                3050: {
                    slidesPerView: 4,
                },
            }
        });
    }());

    initGalleryOnClones();
    function initGalleryOnClones() {
        lightGallery(document.querySelector('[data-detail-project-gallery] .swiper-wrapper'), {
            selector: '.swiper-slide-duplicate .JS-lightgallery-item'
        });
    }

});